import store from '@/store'
import { SET_LOADING_STATUS, SET_STATUS_MESSAGE } from './mutation-types'
import {
  INIT_ORGS,
  INIT_TITLES,
  SPLICE_ORGS,
  SPLICE_TITLES,
  SET_ORG_TOTAL_COUNT,
  SET_TITLE_TOTAL_COUNT,
  CLEAR_ORGS,
  CLEAR_TITLES
}
  from './work-history-mutation-types'

const state = {
  organizations: [],
  titles: [],
  orgTotalCount: 0,
  titleTotalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllOrganizations: (state) => {
    return state.organizations
  },
  getAllTitles: (state) => {
    return state.titles
  },
  getOrgTotalCount: (state) => {
    return state.orgTotalCount
  },
  getTitleTotalCount: (state) => {
    return state.titleTotalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async initOrgs ({ commit }, { newOrgs, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_ORG_TOTAL_COUNT, { val: totalCount })
      commit(INIT_ORGS, { newOrgs, totalCount: isFullArraySize ? totalCount : newOrgs.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async nextOrgs ({ commit }, { newOrgs, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE_ORGS, { newOrgs, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async initTitles ({ commit }, { newTitles, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_ORG_TOTAL_COUNT, { val: totalCount })
      commit(INIT_TITLES, { newTitles, totalCount: isFullArraySize ? totalCount : newTitles.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async nextTitles ({ commit }, { newTitles, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE_TITLES, { newTitles, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  clearOrgs ({ commit }) {
    commit(CLEAR_ORGS)
  },
  clearTitles ({ commit }) {
    commit(CLEAR_TITLES)
  },
  setOrgTotalCount ({ commit }, { val }) {
    commit(SET_ORG_TOTAL_COUNT, { val })
  },
  setTitleTotalCount ({ commit }, { val }) {
    commit(SET_TITLE_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT_ORGS] (state, { newOrgs, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newOrgs))
    state.organizations = new Array(totalCount)
    state.organizations.splice(0, objs.length, ...objs)
  },
  [SPLICE_ORGS] (state, { newOrgs, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newOrgs))
    state.organizations.splice(startIndex, objs.length, ...objs)
  },
  [SET_ORG_TOTAL_COUNT] (state, { val }) {
    state.orgTotalCount = val
  },
  [INIT_TITLES] (state, { newTitles, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newTitles))
    state.titles = new Array(totalCount)
    state.titles.splice(0, objs.length, ...objs)
  },
  [SPLICE_TITLES] (state, { newTitles, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newTitles))
    state.titles.splice(startIndex, objs.length, ...objs)
  },
  [SET_TITLE_TOTAL_COUNT] (state, { val }) {
    state.titleTotalCount = val
  },
  [CLEAR_ORGS] (state) {
    state.organizations = []
    state.orgTotalCount = 0
    state.status = {
      loading: false,
      message: 'Loading.. Please wait...'
    }
  },
  [CLEAR_TITLES] (state) {
    state.titles = []
    state.titleTotalCount = 0
    state.status = {
      loading: false,
      message: 'Loading.. Please wait...'
    }
  }
}

export const workHistory = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
